import { useState } from 'react';

import {
    TFormalOffer,
    TFormalOffers
} from '@helpers/FormalOffers/formalOffers.types';
import { IconUnfoldHorizontal } from '@iwoca/icons';
import { Button } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { ComparisonAndRepaymentModal } from './ComparisonAndRepaymentModal/ComparisonAndRepaymentModal';

export const CompareOffers = ({
    formalOffers,
    drawdownAmount,
    selectedOffer,
    onOpen
}: {
    formalOffers: TFormalOffers;
    drawdownAmount: number;
    selectedOffer?: TFormalOffer;
    onOpen?: () => void;
}) => {
    const [isOpen, setIsOpen] = useState(false);

    if (formalOffers.length <= 1) {
        return null;
    }

    return (
        <div data-testid="compare-offers">
            <Button
                variant="tertiary"
                onClick={() => {
                    onOpen?.();
                    setIsOpen(true);
                }}
            >
                <IconUnfoldHorizontal />
                <FormattedMessage
                    id="_.flexi_approved.compare_loans_button"
                    defaultMessage="Compare these options"
                />
            </Button>
            <ComparisonAndRepaymentModal
                isModalOpen={isOpen}
                onClose={() => setIsOpen(false)}
                formalOffers={formalOffers}
                drawdownAmount={drawdownAmount}
                selectedOffer={selectedOffer}
            />
        </div>
    );
};
